import script from "./VAddFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./VAddFiles.vue?vue&type=script&setup=true&lang=js"

import "./VAddFiles.vue?vue&type=style&index=0&id=1788cdfc&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1788cdfc"]])

export default __exports__